/**
 * Setzt oder entfernt tabindex="-1" für alle Links in einem oder mehreren Menüs
 * @param {HTMLElement|NodeList|Array} menuElement - Menüelement(e), das/die überprüft wird/werden
 * @param {boolean} isActive - true = sichtbar/aktiv, false = unsichtbar
 */
function setTabbingForMenu(menuElement, isActive) {
  if (!menuElement) {
    return;
  }

  // Falls mehrere Menüs übergeben wurden
  const menus = (menuElement instanceof NodeList || Array.isArray(menuElement)) ?
    menuElement :
    [menuElement];

  menus.forEach((menu) => {
    if (!menu) {
      return;
    }

    const links = menu.querySelectorAll('a');
    links.forEach((link) => {
      if (isActive) {
        link.removeAttribute('tabindex');
      } else {
        link.setAttribute('tabindex', '-1');
      }
    });
  });
}

/**
 * Öffnet das Side-Menu UI (sichtbar, Header verstecken, Body locken)
 */
function showSideMenuUI(sideNavigation, overlay, topNavigation) {

  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  document.body.style.paddingRight = `${scrollbarWidth}px`;
  topNavigation.querySelector('.top-navigation__bar').classList.remove('shrink');
  document.body.classList.add('sideMenuOpen');

  if (topNavigation) {
    topNavigation.classList.add('header--hidden');
  }


  if (overlay) {
    // eslint-disable-next-line no-restricted-globals
    setTimeout(() => {
      overlay.classList.add('is-visible');
    }, 100); // 500ms Verzögerung (anpassbar)
  }

  if (sideNavigation) {
    // eslint-disable-next-line no-restricted-globals
    setTimeout(() => {
      sideNavigation.classList.add('is-visible');
    }, 200); // 500ms Verzögerung (anpassbar)
  }
}

/**
 * Schließt das Side-Menu UI (unsichtbar, Header zeigen, Body unlocken)
 */
function hideSideMenuUI(sideNavigation, overlay, topNavigation) {
  document.body.style.paddingRight = '';

  if (sideNavigation) {
    sideNavigation.classList.remove('is-visible');
  }

  if (topNavigation) {
    topNavigation.classList.remove('header--hidden');
    topNavigation.querySelector('.top-navigation__bar').classList.add('shrink');
  }

  if (overlay) {
    overlay.classList.remove('is-visible');
  }

  document.body.classList.remove('sideMenuOpen');
}

/**
 * Setzt oder entfernt das 'inert'-Attribut und Tabindex bei inaktiven Menüs.
 * @param {HTMLElement} sideMenu - Das SideMenu-Element, das geprüft werden soll.
 */
function setInertByActiveMenus(sideMenu) {
  if (!sideMenu) {
    return;
  }

  const allMenus = sideMenu.querySelectorAll('.nav__menu-1, .nav__menu-2, .nav__menu-3');

  allMenus.forEach((menu) => {
    const isActive = menu.classList.contains('slide-in');

    menu.querySelectorAll('button, a, input, select, textarea').forEach((el) => {
      if (!isActive) {
        el.setAttribute('inert', '');
        el.setAttribute('tabindex', '-1');
      } else {
        el.removeAttribute('inert');
        el.removeAttribute('tabindex');
      }
    });
  });
}

function setUserCentricsCustomStyle() {
  // eslint-disable-next-line no-restricted-globals
  setTimeout(() => {
    const rootEl = document.querySelector('#usercentrics-root');
    if (!rootEl || !rootEl.shadowRoot) {
      return false;
    }

    const privacyButton = rootEl.shadowRoot.querySelector('[data-testid="uc-privacy-button"]');
    if (!privacyButton) {
      return false;
    }

    privacyButton.style.zIndex = '3900';

    return true;
  }, 500);
}

export {
  setTabbingForMenu,
  showSideMenuUI,
  hideSideMenuUI,
  setInertByActiveMenus,
  setUserCentricsCustomStyle,
};
